export default __webpack_public_path__ + "de5c444c713e1aead6d734edc8188732.png";